<div class="flex-space-between" *ngIf="techniciansAllowed || isRentals">
  <div class="bold">
    <div *ngIf="isWorkshop && techniciansAllowed <= 4">{{'bikeshop.users.technicians_allowed' | translate : {
      techniciansAllowed:
      techniciansAllowed
    } }}</div>
  </div>
  <button class="iso-round-button mb-2" [disabled]="loading || !canAddStaff"
          (click)="newStaff()">
    {{ 'bikeshop.users.add_new_staff' | translate}}</button>
</div>

<div class="">
  <table class="staff-table">
    <thead>
    <tr>
      <th style="width: 30px;"></th>
      <th>{{ 'general.name' | translate}}</th>
      <th>{{ 'general.email_username' | translate}}</th>
      <th *ngIf="isWorkshop">{{ 'bikeshop.users.system_role' | translate}}</th>
      <th *ngIf="!isWorkshop"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let user of users" (click)="editStaff(user)">
      <!-- <td class="user-indicator"><span [ngStyle]="{'background': '#'+intToRGB(hashCode(user.Name +' '+user.Surname))}"></span></td> -->
      <td class="user-indicator">
        <avatar size=30 name="{{user.Name+' '+user.Surname}}"></avatar>
      </td>
      <td>{{ user.Name }} {{ user.Surname }}</td>
      <td>{{ user.Email }}</td>
      <td *ngIf="isWorkshop">
          <span *ngFor="let role of user.UserRoles; let i = index" style="text-transform: capitalize;">{{ getRole(role)
            }}<span *ngIf="i!==(user.UserRoles.length-1)">; </span></span>
      </td>
      <td *ngIf="!isWorkshop"></td>
    </tr>
    </tbody>
  </table>
</div>

<!-- user.UserRoles.reduce((previous, current)=>{
            return ((Number.isInteger(previous) ? roles[previous-1]: previous) + ', '+roles[current-1])
          }) -->
